import { VerticalContainer } from '@american-autonomy/ag-ui';

import Link from 'components/Link';
import BodyText from 'components/text/BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ChemicalDetailDocuments: FunctionComponent<Props> = ({
    documents,
    testId = TEST_ID,
    title
}) => (
    <VerticalContainer className={styles.documentsSection} testId={testId}>
        <BodyText className={styles.sectionTitle} text={title} />

        {documents.map(({ description, type, url }) => (
            <Link key={url} text={`${type}: ${description}`} to={url} />
        ))}
    </VerticalContainer>
);

export default ChemicalDetailDocuments;
